import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  FormState,
  UniversityCreateRequest,
  UniversityResponse,
  UniversityUpdateRequest,
} from '../../types';

@Injectable({
  providedIn: 'root',
})
export class UniversityService {
  items: UniversityResponse[] = [];
  listLoading = false;
  isNew = true;
  formState: FormState<UniversityResponse> = {
    loading: false,
    item: UniversityService.factoryItem(),
  };

  constructor(private http: HttpClient) {}

  static factoryItem(): UniversityResponse {
    return {
      translationKey: '',
      country: 'DEU',
      names: {
        de: '',
        en: '',
      },
      description: '',
      testTemplatesForApplications: [],
      testTemplatesForAutoSend: [],
    };
  }

  loadList(): Promise<UniversityResponse[]> {
    this.listLoading = true;
    const promise = firstValueFrom(
      this.http.get<UniversityResponse[]>('/api/university')
    ).then((items) => (this.items = items));

    promise.finally(() => (this.listLoading = false));
    return promise;
  }

  loadByTranslationKey(
    translationKey: string
  ): Promise<UniversityResponse> {
    return this.loadList().then((items) => {
      const item = items.find(
        (university) =>
          university.translationKey === translationKey
      );
      if (!item) {
        throw new Error('University not found');
      }
      return item;
    });
  }

  save(): Promise<UniversityResponse> {
    this.formState.loading = true;
    const item = this.formState.item;
    const updateRequest: UniversityUpdateRequest = {
      country: item.country,
      names: item.names,
      description: item.description,
      testTemplatesForApplications:
        item.testTemplatesForApplications,
      testTemplatesForAutoSend:
        item.testTemplatesForAutoSend,
    };

    const promise = this.isNew
      ? firstValueFrom(
          this.http.post<UniversityResponse>(
            '/api/university',
            {
              translationKey: item.translationKey,
              ...updateRequest,
            } as UniversityCreateRequest
          )
        )
      : firstValueFrom(
          this.http.put<UniversityResponse>(
            `/api/university/${encodeURIComponent(
              item.translationKey
            )}`,
            updateRequest
          )
        );

    promise.finally(() => (this.formState.loading = false));
    return promise;
  }
}
